// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4015":"ab749ca4","8220":"ab749ca4"}[chunkId] + ".chunk.css";
};